import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from 'utils/api';
import { MDBIcon } from "mdbreact";
import {
  Alert,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupText,
  InputGroup,
  Media,
  Col,
  Button
} from "reactstrap";
import { Dots } from 'react-preloaders';

const imageHeader = {
  borderRadius: '40px'
};
const loginHeader = {
  fontWeight: 500,
  fontSize: '20px'
};
const alertStyle = {
  fontSize: '13px'
};
const characterSettings = {
  fontWeight: 500,
  color: 'black'
};

const ChangePassword = props => {
  let history = useHistory();

  const [openAlert, setOpenAlert] = useState(false);
  const [loading, setLoading] = useState(false);

  const [settings, setSettings] = useState([]);
  const [passwordHistory, setPasswordHistory] = useState([]);

  const [formState, setFormState] = useState({
    values: { newPassword: '', confirmPassword: '' },
    showNewPassword: false,
    showConfirmPassword: false,
    errorColor: 'success',
    errorMessage: 'Your password has been successfully changed. You will be redirected in login page within 5 seconds.'
  });


  const minPasswordLength = 8;
  const minSpecialCharacters = 2;
  const enforcePasswordHistory = 1;

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      let prevLocation = history.location.state?.from;

      if (prevLocation) {
        if (prevLocation !== `validatetoken`) {
          // not from token validation page, redirect to login. 
          history.push('/auth/login');
        }
      } else {
        // not from token validation page, redirect to login. 
        history.push('/auth/login');
      }

      const authToken = localStorage.getItem('validationToken');
      let tokenVal = '';
      if (authToken !== undefined && authToken !== null) {
        tokenVal = authToken;
      }

      // axios.get(`merchant/getmerchant?merchantGroupId=${localStorage.getItem('userId')}`, { headers: { "Authorization": `Bearer ${tokenVal}` } })
      axios.get(`merchant/getmerchant`, { headers: { "Authorization": `Bearer ${tokenVal}` } })
        .then(response => {
          // const merchantGroupId = response.data.merchant.merchantGroupID;
          //const enforcePasswordHistory = localStorage.getItem('enforcePasswordHistory');

          setSettings(response.data.settings);

          axios.get(`merchant/getpasswordhistory?enforcePasswordHistory=${enforcePasswordHistory}`, { headers: { "Authorization": `Bearer ${tokenVal}` } })
            .then(history => {
              setPasswordHistory(history.data.history);
            });
        })
        .catch(() => {
          setFormState(formState => ({
            ...formState,
            errorColor: 'danger',
            errorMessage: 'There is a problem retrieving your account information. Please try again later.'
          }));

          setOpenAlert(true);
        });
    }

    return () => {
      mounted = false;
    };
  }, []);

  const handleAlertClose = () => {
    setOpenAlert(false);
  };

  const handleChange = (event, value, param) => {
    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [param]: value
      },
      touched: {
        ...formState.touched,
        [param]: true
      }
    }));
  };

  const handleShowPassword = (event) => {
    if (event === 'newPassword')
      setFormState({ ...formState, showNewPassword: !formState.showNewPassword });
    else
      setFormState({ ...formState, showConfirmPassword: !formState.showConfirmPassword });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (settings.length !== 0) {
      if (formState.values.newPassword !== '' && formState.values.confirmPassword !== '') {
        if (formState.values.newPassword.trim().length >= parseInt(minPasswordLength) && formState.values.newPassword.indexOf(' ') === -1 &&
          specialCharCount >= parseInt(minSpecialCharacters) && formState.values.newPassword === formState.values.confirmPassword &&
          !passwordHistory.some(x => x.password === formState.values.newPassword)) {
          setLoading(true);

          const authToken = localStorage.getItem('validationToken');
          let tokenVal = '';
          if (authToken !== undefined && authToken !== null) {
            tokenVal = authToken;
          }

          axios.post('merchant/changepassword',
            {
              merchant: {
                // merchantId: parseInt(localStorage.getItem('userId')),
                password: formState.values.newPassword
              }
            },
            { headers: { "Authorization": `Bearer ${tokenVal}` } }
          )
            .then(() => {
              setFormState(formState => ({
                ...formState,
                errorColor: 'success',
                errorMessage: 'Your password has been successfully changed. You will be redirected in login page within 5 seconds.'
              }));

              setOpenAlert(true);

              setTimeout(function () {
                history.push('/auth/login');
              }, 5000);
            }).catch(((err) => {
              setFormState(formState => ({
                ...formState,
                errorColor: 'danger',
                errorMessage: 'There is a problem changing your password. Please try again later.'
              }));

              setOpenAlert(true);
            }));
        } else {
          setFormState(formState => ({
            ...formState,
            errorColor: 'danger',
            errorMessage: 'New password and confirm password must follow the standard settings stated below.'
          }));

          setOpenAlert(true);
        }
      } else {
        setFormState(formState => ({
          ...formState,
          errorColor: 'danger',
          errorMessage: 'New password and confirm password fields are required.'
        }));

        setOpenAlert(true);
      }
    } else {
      setFormState(formState => ({
        ...formState,
        errorColor: 'danger',
        errorMessage: 'There is a problem retrieving the system settings. Please try again later.'
      }));

      setOpenAlert(true);
    }

    setLoading(false);
  }

  //eslint-disable-next-line
  var passwordRegex = formState.values.newPassword.match(/[`~!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g);
  var specialCharCount = 0;

  if (passwordRegex !== null)
    specialCharCount = parseInt(passwordRegex.length);

  document.body.style.overflow = '';
  document.body.style.position = 'relative';

  return (
    <>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">
          <CardBody className="px-lg-5 py-lg-5">
            <p style={{ textAlign: "center" }}>
              <Media object width="100" style={imageHeader} src={require("assets/img/brand/change_password.png")} alt="Change password" />
            </p>
            <div className="text-center mb-4" style={loginHeader}>
              Change Your Password
            </div>
            <div className="text-center text-muted mb-4">
              <small>It's a good idea to use a strong password that you don't use elsewhere.</small>
            </div>
            <hr />
            <Form role="form">
              {
                loading && <Dots background="rgba(192,192,192,0.3)" customLoading={loading} color="#000099" />
              }
              {
                openAlert &&
                (<Alert style={alertStyle} color={formState.errorColor} isOpen={openAlert} toggle={handleAlertClose} fade={true}>
                  {formState.errorMessage}
                </Alert>)
              }
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <Input
                    placeholder="New Password"
                    type={formState.showNewPassword ? "text" : "password"}
                    onChange={event => handleChange(event, event.target.value, event.target.name)}
                    onKeyPress={event => { if (event.key === 'Enter') { handleSubmit(event) } }}
                    onPaste={(e) => { e.preventDefault(); return false; }}
                    onCopy={(e) => { e.preventDefault(); return false; }}
                    name="newPassword"
                    value={formState.values.newPassword || ''}
                    autoComplete="off" />
                  <InputGroupText onClick={() => { handleShowPassword("newPassword") }}>
                    <MDBIcon icon={formState.showNewPassword ? "eye-slash" : "eye"} />
                  </InputGroupText>
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <Input
                    placeholder="Confirm Password"
                    type={formState.showConfirmPassword ? "text" : "password"}
                    onChange={event => handleChange(event, event.target.value, event.target.name)}
                    onKeyPress={event => { if (event.key === 'Enter') { handleSubmit(event) } }}
                    onPaste={(e) => { e.preventDefault(); return false; }}
                    onCopy={(e) => { e.preventDefault(); return false; }}
                    name="confirmPassword"
                    value={formState.values.confirmPassword || ''}
                    required
                    data-error="Confirm Password is required"
                    autoComplete="off" />
                  <InputGroupText onClick={() => { handleShowPassword("confirmPassword") }}>
                    <MDBIcon icon={formState.showConfirmPassword ? "eye-slash" : "eye"} />
                  </InputGroupText>
                </InputGroup>
              </FormGroup>
              <div className="text-muted mb-4" hidden={settings.length === 0}>
                <small>New password must:</small><br />
                <small style={{ textDecoration: (formState.values.newPassword === formState.values.confirmPassword && formState.values.newPassword !== "") ? "line-through" : "none" }}>- Match with the password confirmation.</small><br />
                <small style={{ textDecoration: ((!passwordHistory.some(x => x.password === formState.values.newPassword) && formState.values.newPassword !== "") ? "line-through" : "none") }}>- Not match with the <span style={characterSettings}>({enforcePasswordHistory})</span> previous password(s) history.</small><br />
                <small style={{ textDecoration: (specialCharCount >= parseInt(minSpecialCharacters)) ? "line-through" : "none" }}>- Contain at least <span style={characterSettings}>({minSpecialCharacters})</span> special character(s).</small><br />
                <small style={{ textDecoration: (formState.values.newPassword.trim().length >= parseInt(minPasswordLength)) ? "line-through" : "none" }}>- Contain at least <span style={characterSettings}>({minPasswordLength})</span> character(s).</small>
              </div>
              <div className="text-center">
                <Button
                  color="info"
                  href="#pablo"
                  disabled={!(!(settings.length === 0) || (formState.values.newPassword === formState.values.confirmPassword &&
                    formState.values.newPassword !== '' && (!passwordHistory.some(x => x.password === formState.values.newPassword)) &&
                    specialCharCount >= parseInt(minSpecialCharacters) && formState.values.newPassword.trim().length >= parseInt(minPasswordLength)))
                  }
                  onClick={handleSubmit}
                  className="btn-block">
                  Change Password
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </>
  );
}

export default ChangePassword;
